@if (isLoading) {
  <app-preloader [type]="preloaderTypes.OVERLAY"></app-preloader>
}

<div mat-dialog-title>
  <div class="dialog-caption c-primary">Payment details</div>

  <button mat-dialog-close class="btn icon-close ic-secondary"></button>

  <div class="align-h-space-between c-secondary fw-normal fs-big">
    <div>Total to pay</div>
    <div>{{data.subscription.price | customCurrency}}/{{ data.subscription.frequency }}</div>
  </div>
</div>

<div mat-dialog-content>
  @if (errorMessage) {
    <div id="error-message" class="form-group-error">
      {{errorMessage}}
    </div>
  }

  @if ((paymentMethods$ | async); as paymentMethods) {
    @if (paymentMethods.length) {
      <mat-radio-group class="default full-width" [(ngModel)]="selectedPaymentMethod">
        @for (paymentMethod of paymentMethods; track paymentMethod) {
          <mat-radio-button [value]="paymentMethod" color="primary"
            class="d-block pv-15">
            <div class="align-h-space-between align-v-center">
              <div class="c-secondary fs-default fw-bold">
                {{paymentMethod.description}}
                @if (paymentMethod.isDefault) {
                  <div class="status-badge-approved ml-10">Primary</div>
                }
              </div>
              @if (paymentMethod.logo) {
                <div
                  class="payment-method-logo mr-10"
                  [ngStyle]="{'backgroundImage': 'url(' + paymentMethod.logo + ')'}">
                </div>
              } @else {
                <div class="payment-method-logo align-v-center align-h-center mr-10">
                  <i class="icon-bank ic-text"></i>
                </div>
              }
            </div>
          </mat-radio-button>
        }
        <mat-radio-button class="d-block pv-15" color="primary" [value]="null">Another payment method</mat-radio-button>
      </mat-radio-group>
    }
  }

  <form [class.d-none]="selectedPaymentMethod !== null" id="payment-form" class="p-15">
    <!-- Elements will create form elements here -->
    <div id="payment-element"></div>
  </form>
</div>

<div mat-dialog-actions>
  <div class="row g-3 align-h-right">
    <div class="col-6 col-sm-auto">
      <button mat-dialog-close class="btn basic w-100">Cancel</button>
    </div>
    <div class="col-6 col-sm-auto">
      <button id="individual-subscribe-button"
              class="btn primary w-100"
              data-event="subscribe"
              data-platform="taxtank"
              data-purpose="subscription"
              (click)="submit()"
              [disabled]="selectedPaymentMethod === undefined">
        Subscribe
      </button>
    </div>
  </div>
</div>
